import React from "react";
import aboutusbanner from "../assets/images/aboutus-banner-1.png";
import aboutusbannertwo from "../assets/images/aboutus-banner-2.png";
import logo from "../assets/logo/Logo.svg";
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react';
import { useNavigate } from "react-router-dom";
import axios from "axios";

const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");
const API_ORIGIN = API_BASE_URL.replace(/\/api$/i, "");
export default function AboutUs() {
  const navigate = useNavigate();


  const handleAboutUsClick = async () => {
    try {
      const res = await axios.post(
        `${API_ORIGIN}/admin-api/cms/content`,
        { slug: "about-us" }
      );
      // Pass the content to the new page using state
      navigate("/about-us-detail", { state: { content: res.data } });
    } catch (error) {
      alert("Failed to load About Us content.");
    }
  };
  const handleTermsClick = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post(
        `${API_ORIGIN}/admin-api/cms/content`,
        { slug: "terms-and-conditions" }
      );
      navigate("/about-us-detail", { state: { content: res.data } });
    } catch (error) {
      alert("Failed to load Terms and Conditions.");
    }
  };
  const handlePrivacyPolicyClick = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post(
        `${API_ORIGIN}/admin-api/cms/content`,
        { slug: "privacy-policy" }
      );
      navigate("/about-us-detail", { state: { content: res.data } });
    } catch (error) {
      alert("Failed to load Privacy Policy.");
    }
  };

  return (
    <div className=" aboutus-page abt-banner-sec w-full">
      <div className="w-full">
        <div className="container">
          <div className="max-w-5xl mx-auto mt-1 mb-0 flex justify-between items-center relative">
            {/* <img src="" alt="Pipaan Logo" className=" mb-0 w-36" /> */}
            <div></div>
            {/* Language selector */}
            <div className="flex justify-end  menu">

              <Menu as="div" className=" language-btn relative inline-block text-left">
                <div>
                  <MenuButton className="inline-flex w-full justify-center gap-x-1.5 rounded-md px-3 pt-2 pb-0 text-sm align-center  hover:bg-gray-50">
                    English
                    <svg width="10" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12.92 0.179932H6.68999H1.07999C0.119992 0.179932 -0.360007 1.33993 0.319993 2.01993L5.49999 7.19993C6.32999 8.02993 7.67999 8.02993 8.50999 7.19993L10.48 5.22993L13.69 2.01993C14.36 1.33993 13.88 0.179932 12.92 0.179932Z" fill="#292D32" />
                    </svg>
                  </MenuButton>
                </div>

                <MenuItems
                  transition
                  className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                >
                  <div className="py-1">
                    <MenuItem>
                      <a
                        href="#"
                        className="block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none"
                      >                      </a>
                    </MenuItem>
                    <MenuItem>
                      <a
                        href="#"
                        className="block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none"
                      >

                      </a>
                    </MenuItem>
                    <MenuItem>
                      <a
                        href="#"
                        className="block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none"
                      >

                      </a>
                    </MenuItem>
                    <form action="#" method="POST">
                      <MenuItem>
                        <button
                          type="submit"
                          className="block w-full px-4 py-2 text-left text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none"
                        >
                        </button>
                      </MenuItem>
                    </form>
                  </div>
                </MenuItems>
              </Menu>
            </div>
          </div>
          <div className="max-w-5xl mx-auto mb-lg-5 flex justify-between items-center">
            <img src={logo} alt="Pipaan Logo" className="logo mb-0 w-36" />
            <div className="mt-0">
              <button className="login-cta text-sm text-white bg-[#161F28] rounded-full">Login</button>
            </div>
          </div>
          <div className="relative px-6 pt-10 pb-16 text-center lg:pt-16 lg:pb-24">

            <div className="max-w-5xl mx-auto">
              <h1 className="about-title text-3xl font-bold text-[#095228]-800 sm:text-5xl mb-4">
                Bringing People Closer, <br className="hidden sm:block" /> One Click at a Time.
              </h1>
              <p className="aboutus-des max-w-4xl mx-auto text-gray-600 mb-6">
                Join a vibrant community where people come together to express themselves,
                discover new interests, and build lasting connections.
              </p>
              <button className="crt-account px-6 py-3 text-white bg-[#161F28] rounded-full hover:bg-green-800 transition">
                Create Your Account
              </button>
              {/* <div className="mt-6">
            <button className="text-sm text-white bg-black px-5 py-2 rounded-full">Login</button>
          </div> */}
            </div>
            <div className=" about-banner-img mt-8 max-w-5xl mx-auto relative">
              <div className="absolute flex items-center justify-center">
                <img src={aboutusbanner} alt="Hero" className="rounded-xl w-full" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className=" max-w-8xl mx-auto bg-white py-6 px-3">
        {/* About Us Section */}
        <div className=" px-6 py-lg-16  aboutus-sec bg-white container">
          <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
            {/* Images */}
            <div className="">
              <img src={aboutusbannertwo} alt="User 1" className=" w-full" />
            </div>

            {/* Text */}
            <div>
              <h2
                className="abt-us-h2 mb-6 cursor-pointer"
                onClick={handleAboutUsClick}
              >
                About Us
              </h2>
              <div className="space-y-6 abt-us-p">
                {[...Array(4)].map((_, i) => (
                  <p key={i}>
                    We move with make a Creative Strategy for help your business goal, we help to improve your income by a services we have. make your content look interesting and make people look for your business
                  </p>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Footer */}
      <footer className="abt-footer max-w-8xl mx-auto flex justify-between items-center bg-[#095228] text-white text-sm py-6 px-3 text-center">
        <p className="copy">&copy; 2025 Pipaan. All Rights Reserved</p>
        <div className="mt-2 terms-condition">
          <a
            href="#"
            className="mx-2 underline"
            onClick={handleTermsClick}
          >
            Terms of use
          </a>
          <a
            href="#"
            className="mx-2 underline"
            onClick={handlePrivacyPolicyClick}
          >
            Privacy policy
          </a>
        </div>
      </footer>
    </div>
  );
}